import { render } from "./IconBankIDLarge.vue?vue&type=template&id=b7c71dba"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__